import './chunk-455cdeae.js';
import './chunk-e92e3389.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { F as Field } from './chunk-d46e7ff0.js';
export { F as BField } from './chunk-d46e7ff0.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Field);
  }
};
use(Plugin);

export default Plugin;
